export enum AddressTypes {
	home = 0,
	work = 1,
	delivery = 2,
	other = 3
}
